import { useState } from 'react';
import { ArrowContainer, Popover, PopoverPosition } from 'react-tiny-popover';
import { WITHDRAW_RESTRICTION_DEFAULT_TEXT } from '@/utils/constants';

interface Props {
    children: React.ReactNode;
    positions: PopoverPosition[];
    className?: string;
    text?: string | null;
}

const HoldWrapper = ({ children, positions, className, text }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Popover
            isOpen={isOpen}
            positions={positions}
            padding={10}
            // Keep the popover inside the viewport: reposition lets it flip to
            // another of `positions` (and shift along the edge) instead of
            // overflowing off-screen. boundaryInset keeps a gap from the edge.
            reposition={true}
            boundaryInset={8}
            onClickOutside={() => setIsOpen(false)}
            content={({ position, childRect, popoverRect }) => (
                <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                    position={position}
                    childRect={childRect}
                    arrowColor={'#2D3032'}
                    arrowSize={8}
                    arrowStyle={{ opacity: 1 }}
                    className={''}
                    arrowClassName={'ml-[1px]'}
                    popoverRect={popoverRect}
                >
                    <div
                        className={
                            'bg-gray p-2 px-3 rounded-lg text-text_gray text-sm cursor-pointer flex flex-col gap-2 font-semibold border-gray_two border max-w-[260px] break-words'
                        }
                    >
                        <p>{text || WITHDRAW_RESTRICTION_DEFAULT_TEXT}</p>
                    </div>
                </ArrowContainer>
            )}
        >
            <div
                className={className}
                onMouseLeave={() => setIsOpen(false)}
                onMouseEnter={() => setIsOpen(true)}
            >
                {children}
            </div>
        </Popover>
    );
};

export default HoldWrapper;
